import CONFIG from 'config';
import RCSLoggerFactory from 'rcs_logger';

export const gptExtensionsLogger = RCSLoggerFactory.init('[GPT EXTENSIONS]', {
    level: CONFIG.build.env === 'prod' && !location.href.includes('gptLogs=true') ? 'error' : 'debug',
});

export const runGptExtensions = function (gptExtensions, id) {
    const start = performance.now();

    gptExtensionsLogger.debug(`Running ${id} extensions, ${gptExtensions[id]?.length || 0} found`);
    if (gptExtensions[id]) {
        gptExtensions[id].sort((a, b) => a.execOrder - b.execOrder);
        gptExtensions[id].forEach((extension) => {
            extension.fn();
            if (typeof extension.callback === 'function') {
                extension.callback();
            }
        });
    }

    gptExtensionsLogger.debug(`Running ${id} extensions took ${(performance.now() - start).toFixed(2)} ms`);
};

export function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has(param)) {
        const value = urlParams.get(param);

        return value === null ? '' : value;
    }

    return null;
}

export function runAtDOMContentLoaded(fn) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', (_) => {
            fn();
        });
    } else {
        fn();
    }
}
